import { render, staticRenderFns } from "./manifests.vue?vue&type=template&id=1f88871a"
import script from "./manifests.vue?vue&type=script&lang=js"
export * from "./manifests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports